var _path, _path2, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 30,
    viewBox: "0 0 40 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.171 1H15.9061C14.5834 1 13.3463 1.65383 12.6012 2.74665L12.1341 3.43165C11.4041 4.50243 10.2004 5.15314 8.90469 5.17759L4.92454 5.25268C2.7452 5.2938 1 7.07225 1 9.25198V24.8416C1 27.0507 2.79086 28.8416 5 28.8416H34.9355C37.1697 28.8416 38.9707 27.0115 38.935 24.7776L38.6855 9.18479C38.651 7.03194 36.9187 5.29263 34.766 5.24958L31.2042 5.17834C29.9529 5.15331 28.7854 4.54403 28.0493 3.53183L27.406 2.64731C26.6533 1.61234 25.4508 1 24.171 1Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96045 3.82177H6.17802C5.62154 3.82177 5.18672 3.3413 5.24209 2.78758C5.29017 2.30675 5.69479 1.94058 6.17802 1.94058H7.96045C8.47993 1.94058 8.90105 2.3617 8.90105 2.88118C8.90105 3.40065 8.47993 3.82177 7.96045 3.82177Z",
    stroke: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 16.6139,
    r: 7.21287,
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.7822,
    cy: 9.08911,
    r: 0.816832,
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.24faed5c3c25b8b0d3490f30d772606a.svg";
export { ForwardRef as ReactComponent };